const TENANT_ID_KEY = 'selectedTenantId'

export const getSelectedTenantId = (): string | null => {
  const pinnedToTab = sessionStorage.getItem(TENANT_ID_KEY)
  if (pinnedToTab) return pinnedToTab

  const lastSelected = localStorage.getItem(TENANT_ID_KEY)
  if (!lastSelected) return null

  // Pin the carried-over tenant to this tab, so switching tenant in another tab cannot retarget it.
  sessionStorage.setItem(TENANT_ID_KEY, lastSelected)
  return lastSelected
}

export const setSelectedTenantId = (tenantId: string): void => {
  sessionStorage.setItem(TENANT_ID_KEY, tenantId)
  localStorage.setItem(TENANT_ID_KEY, tenantId)
}

export const clearSelectedTenantId = (): void => {
  sessionStorage.removeItem(TENANT_ID_KEY)
  localStorage.removeItem(TENANT_ID_KEY)
}
